import axios, { Canceler, AxiosRequestConfig } from 'axios';
import { ServerErrorHandling } from './errorHandling';
import { store } from '../../index';
import queryBuilder from '../../utils/query-builder'

interface IapiCreator {
    headers: any,
    method: 'get' | 'post' | 'put' | 'patch' | 'delete',
    url: string,
    data: any,
    token?: string,
    query?: any,
    responseType?: | 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream',
    ott?: string
    hasErr?: boolean
    isRefresh?: boolean
}

const config: AxiosRequestConfig = {
    baseURL: process.env.BASE_URL,
    timeout: 1200000,
    responseType: 'json',
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    onUploadProgress: (progressEvent: ProgressEvent) => { },
    onDownloadProgress: (progressEvent: ProgressEvent) => { },
    maxContentLength: 2000,
    maxBodyLength: 2000,
    validateStatus: (status: number) => status >= 200 && status < 300,
    maxRedirects: 5,
    cancelToken: new axios.CancelToken((cancel: Canceler) => { })
};

const ApiCreator = async ({ data, headers, method, query = '', token, url, responseType, ott, hasErr = true, isRefresh }: IapiCreator) => {
    const Authorization_ = 'Bearer ' + store.getState().authorization.access_token || token;
    const customConfig = {
        ...config,
        headers: {
            'Accept-Language': 'fa',
            ...(Authorization_ !== "Bearer " && { Authorization: Authorization_ }),
            ...(ott && { ott: `Bearer ${ott}` }),
            ...(headers && { ...headers }),
        },
        url: `${url}${query && queryBuilder(query)}`,
        method: method,
        data: data,
        ...(responseType && { responseType: responseType })
    }
    return await axios(customConfig)
        .then((res) => res.data).catch(hasErr ? (err) => ServerErrorHandling(err, isRefresh) : (err) => err.response)
    // .then((res) => res.data).catch(hasErr?(err) => console.log('hasError',err):(err) =>  console.log('hasNotError',err))
};

interface Iapi {
    header?: any,
    url: string,
    data?: any,
    token?: string,
    query?: any,
    responseType?: | 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream',
    ott?: string,
    hasErr?: boolean
    isRefresh?: boolean
}

class Api {
    static GET = (Iapi: Iapi) => ApiCreator({ headers: Iapi.header, method: 'get', url: Iapi.url, data: Iapi.data, token: Iapi.token, query: Iapi.query, responseType: Iapi.responseType, hasErr: Iapi.hasErr });

    static POST = (Iapi: Iapi) => ApiCreator({ headers: Iapi.header, method: 'post', url: Iapi.url, data: Iapi.data, token: Iapi.token, ott: Iapi.ott, responseType: Iapi.responseType, isRefresh: Iapi.isRefresh, hasErr: Iapi.hasErr });

    static PUT = (Iapi: Iapi) => ApiCreator({ headers: Iapi.header, method: 'put', url: Iapi.url, data: Iapi.data, token: Iapi.token });

    static PATCH = (Iapi: Iapi) => ApiCreator({ headers: Iapi.header, method: 'patch', url: Iapi.url, data: Iapi.data, token: Iapi.token });

    static DELETE = (Iapi: Iapi) => ApiCreator({ headers: Iapi.header, method: 'delete', url: Iapi.url, data: Iapi.data, token: Iapi.token });
}

export default Api;
